<div style="height: 10px;"></div>
<!-- <footer class="bg-[#2f4157] py-6">
    <div class="max-w-7xl mx-auto h-full flex">
        <div class="flex items-center justify-center w-1/5">
            <a routerLink="user/homepage" class="cursor-pointer">
                <img class="w-[100px]" src="/images/login-icon-green.svg" alt="Logo" class="w-28">
            </a>
        </div>

        <div class="flex flex-col w-1/5 py-8 px-4">
            <h3 class="text-white mb-3 text-base font-semibold">RENT</h3>
            <a href="#" class="text-white text-base mb-2">Buy and sell properties</a>
            <a href="#" class="text-white text-base mb-2">Rent home</a>
            <a href="#" class="text-white text-base mb-2">Build trade-up</a>
        </div>

        <div class="flex flex-col w-1/5 py-8 px-4">
            <h3 class="text-white mb-3 text-base font-semibold">ABOUT</h3>
            <a href="#" class="text-white text-base mb-2">Company</a>
            <a href="#" class="text-white text-base mb-2">How it works</a>
            <a href="#" class="text-white text-base mb-2">Contact</a>
            <a href="#" class="text-white text-base mb-2">Investors</a>
        </div>

        <div class="flex flex-col w-1/5 py-8 px-4">
            <h3 class="text-white mb-3 text-base font-semibold">RESOURCES</h3>
            <a href="#" class="text-white text-base mb-2">Blog</a>
            <a href="#" class="text-white text-base mb-2">Guides</a>
            <a href="#" class="text-white text-base mb-2">FAQ</a>
            <a href="#" class="text-white text-base mb-2">Help Center</a>
        </div>

        <div class="flex flex-col w-1/5 py-8 px-4">
            <h3 class="text-white mb-3 text-base font-semibold">TERMS & PRIVACY</h3>
            <a href="#" class="text-white text-base mb-2">Trust & Safety</a>
            <a href="#" class="text-white text-base mb-2">Terms of Services</a>
            <a href="#" class="text-white text-base mb-2">Privacy Policy</a>
        </div>
    </div>

    <div class="border-t border-[#E8E6F9] mt-4 py-5">
        <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-4">
            <span class="text-white text-base mb-2">©2025 RentzGo. All rights reserved</span>
            <div class="flex space-x-4 mt-2 md:mt-0">
                <a href="#" aria-label="Facebook">
                    <img src="/images/facebook.svg" alt="Facebook" class="w-5 h-5">
                </a>
                <a href="#" aria-label="instagram">
                    <img src="/images/instagram.svg" alt="Twitter" class="w-5 h-5">
                </a>
                <a href="#" aria-label="twitter">
                    <img src="/images/twitter.svg" alt="Instagram" class="w-5 h-5">
                </a>
                <a href="#" aria-label="linkedin">
                    <img src="/images/linkedin.svg" alt="Instagram" class="w-5 h-5">
                </a>
            </div>
        </div>
    </div>
</footer> -->